// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

export type Props = $ReadOnly<{
    type: string,
    onChange: (type: string) => void
}>;

function ZoneTypeSelector({ type, onChange }: Props) {
    const handleChange = (event, newValue) => {
        onChange(newValue);
    };

    return (
        <Tabs
            value={type}
            indicatorColor="primary"
            textColor="primary"
            onChange={handleChange}
            aria-label="Zone list type"
        >
            <Tab
                label={<FormattedMessage
                    id="zoneLists.type.permanent"
                    defaultMessage="Permanent"
                />}
                value="permanent"
            />
            <Tab
                label={<FormattedMessage
                    id="zoneLists.type.temporary"
                    defaultMessage="Temporary"
                />}
                value="temporary"
            />
        </Tabs>
    );
}

export default ZoneTypeSelector;